import { render, staticRenderFns } from "./InstantFinishTest.vue?vue&type=template&id=7cf40548&"
import script from "./InstantFinishTest.vue?vue&type=script&lang=js&"
export * from "./InstantFinishTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports